import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiffDirective } from './directives/diff.directive';
import { LineDiffDirective } from './directives/lineDiff.directive';
import { ProcessingDiffDirective } from './directives/processingDiff.directive';
import { SemanticDiffDirective } from './directives/semanticDiff.directive';
import { LineCompareComponent } from './components/lineCompare.component';

import { DiffMatchPatch } from './models/diffMatchPatch';
import { DiffMatchPatchService } from './services/diffMatchPatch.service';

@NgModule({
  declarations: [
    DiffDirective,
    LineDiffDirective,
    ProcessingDiffDirective,
    SemanticDiffDirective,
    LineCompareComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DiffDirective,
    LineDiffDirective,
    ProcessingDiffDirective,
    SemanticDiffDirective,
    LineCompareComponent
  ],
  providers: [
    DiffMatchPatch,
    DiffMatchPatchService
  ]
})
export class DiffMatchPatchModule { }
